import type {
  Block,
  ListData,
  ListItem,
} from "../../../../models/ManualAuthoring";

import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./bulletList.css";

export default function BulletListEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ListData;

  const updateItemParts = (index: number, newParts: ListItem["textParts"]) => {
    const updated: ListItem[] = [...data.items];
    updated[index] = { textParts: newParts };
    updateBlock(block.id, { items: updated });
  };

  const addItem = () => {
    const updated: ListItem[] = [
      ...data.items,
      { textParts: [{ type: "text", value: "" }] },
    ];

    updateBlock(block.id, { items: updated });
  };

  const removeItem = (index: number) => {
    const updated = data.items.filter((_, i) => i !== index);
    updateBlock(block.id, { items: updated });
  };

  return (
    <div className="pdf-block pdf-bullet-list">
      {(data.items || []).map((item, index) => (
        <div key={index} className="pdf-bullet-list__row">
          <span className="pdf-bullet-list__bullet">•</span>

          <div className="pdf-bullet-list__text">
            <StructuredInlineTextEditor
              textParts={item.textParts || []}
              onChange={(newParts) => updateItemParts(index, newParts)}
              onDone={onDone}
            />
          </div>

          <button
            className="pdf-bullet-list__remove"
            onClick={() => removeItem(index)}
            type="button"
          >
            ×
          </button>
        </div>
      ))}

      <button
        className="pdf-bullet-list__add"
        onClick={addItem}
        type="button"
      >
        + Add Item
      </button>
    </div>
  );
}
